import { createContext, useContext, useState, useEffect } from "react";
import { apiFetch } from "../../hooks/apiFetch";
import { UserPaymentProvider } from "./UserPaymentContext";
import { UserOrderProvider } from "./UserOrderContext";
import { UserCartProvider } from "./UserCartContext";
import Cookies from 'js-cookie';
import { UserFavProvider } from "./UserFavContext";

const UserContext = createContext();

export function UserProvider({ children }) {
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isLogIn, setIsLogIn] = useState(false);


    useEffect(() => {
        if (Cookies.get('token')) {
            setIsLogIn(true);
        }
        if (!isLogIn) {
            setProfile(null);
            setLoading(false);
            return;
        }
        async function fetchProfile() {
            try {
                const data = await apiFetch(`${process.env.REACT_APP_MASAR_API_URL}/users/my-profile`);
                setProfile(data);
            } catch (err) {
                setProfile(null);
            } finally {
                setLoading(false);
            }
        }
        fetchProfile();
    }, [isLogIn]);


    return (
        <UserContext.Provider value={{ profile, loading, setProfile, isLogIn, setIsLogIn, setLoading }}>
            <UserPaymentProvider>
                <UserOrderProvider>
                    <UserCartProvider>
                        <UserFavProvider>
                            {children}
                        </UserFavProvider>
                    </UserCartProvider>
                </UserOrderProvider>
            </UserPaymentProvider>
        </UserContext.Provider>
    );
}

export function useUser() {
    return useContext(UserContext);
}